import { List, fromJS } from 'immutable';
import {
  FETCH_TESTIMONIALS,
  FETCH_TESTIMONIALS_SUCCESS,
  FETCH_TESTIMONIALS_FAIL,
} from './constants';

const initialState = {
  fetching: false,
  data: List(),
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TESTIMONIALS:
      return state.set('fetching', true);
    case FETCH_TESTIMONIALS_SUCCESS: {
      const { data, append } = payload;
      const loaded = fromJS(data);
      const oldData = state.get('data');
      return state.withMutations((s) =>
        s
          .set('data', append ? oldData.concat(loaded) : loaded)
          .set('fetching', false),
      );
    }
    case FETCH_TESTIMONIALS_FAIL:
      return state.set('fetching', false);
    default:
      return state;
  }
}
